const policyTypes = {
  'ALARM LIABILITY': 'Alarm Liability',
  AUTO: 'Auto',
  BONDS: 'Bonds',
  CRIME: 'Crime',
  CYBER: 'Cyber',
  'D & O': 'Directors & Officers',
  'E & O': 'Errors & Omissions',
  'EMPL LAWYERS': 'Employed Lawyers',
  'EMPL PRAC LIABILITY': 'Employment Practices Liability',
  'EXC MANAGEMENT LIABILITY': 'Excess Management Liability',
  'EXCESS CRIME': 'Excess Crime',
  'EXCESS E & O': 'Excess Errors & Omissions',
  'EXCESS TECH E & O': 'Excess Technology Errors & Omissions',
  'EXCESS UMBRELLA': 'Excess Umbrella',
  FIDUCIARY: 'Fiduciary',
  FLOOD: 'Flood',
  'GENERAL LIABILITY': 'General Liability',
  'INT PACKAGE': 'International Package',
  LIABILITY: 'Liability',
  'MANAGEMENT LIABILITY': 'Management Liability',
  PACKAGE: 'Package',
  'POLLUTION LIABILITY': 'Pollution Liability',
  'PRODUCT LIABILITY': 'Product Liability',
  PROPERTY: 'Property',
  'TECH E & O': 'Technology Errors & Omissions',
  TRANSPORTATION: 'Transportation',
  UMBRELLA: 'Umbrella',
  'WORKERS COMP': 'Workers Comp',
}
function prettyPolicyType(policyTypeEnum) {
  if (!policyTypeEnum) {
    return ''
  }
  const prettyPolicyType = policyTypes[policyTypeEnum]
  return prettyPolicyType || policyTypeEnum
}

export { policyTypes, prettyPolicyType }
